import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import type { LoadFileImportListItem } from './useGetLoadFileImports';
import { APIBaseChronos } from '@/api/hosts';
import { useFetcher } from '@/api/useGetFetchConfig';

/** Fetches a single `.dat` import's summary (backs the wizard on deep-link/refresh). */
const useGetLoadFileImport = (
  matterId: string | undefined,
  importId: string | undefined,
  options: { enabled?: boolean; refetchInterval?: number | false } = {},
) => {
  const { enabled = true, refetchInterval = false } = options;
  const fetcher = useFetcher();

  const getLoadFileImport = (): Promise<LoadFileImportListItem> =>
    fetcher(`${APIBaseChronos}/api/relativity/load-file-import/${importId}?matterId=${matterId}`);

  return useQuery([QueryEntity.LoadFileImports, { matterId, importId }], getLoadFileImport, {
    enabled: enabled && !!matterId && !!importId,
    refetchOnWindowFocus: false,
    refetchInterval,
  });
};

export default useGetLoadFileImport;
